<template>
  <div class="mesJustificatifsChargeDocument mt-5">
    <div class="charge-document">
      <div
        class="charge-document-component questionnaire-sante-component"
        style="cursor: pointer;"
        @click="$bvModal.show('modal-questionnaire-sante')"
      >
        <div class="charge-document-content">
          <img :src="require('@/assets/file-minus.png')" /><br />
          QUESTIONNAIRE DE SANTÉ<br />
          <img
            v-if="this.isPresent === true"
            class="charge-document-icon"
            :src="require('@/assets/check-document.png')"
          />
          <img
            v-if="this.isPresent === false"
            class="charge-document-icon"
            :src="require('@/assets/missing-document.png')"
          />
        </div>
      </div>
    </div>

    <b-modal
      centered
      id="modal-questionnaire-sante"
      ref="modal-questionnaire-sante"
      @show="resetModale"
      @hidden="resetModale"
    >
      <div v-if="getAgeParDateCourante() >= 18" class="row mt-3 ml-5">
        <div @click="downloadQuestionnaireSanteMajeur">
          <img
            :src="require('@/assets/download.png')"
            style="cursor:pointer;"
          />
        </div>
        <div
          class="mes-justificatifs-text downloadQuestionnaireSante ml-2"
          @click="downloadQuestionnaireSanteMajeur"
        >
          {{ "questionnaire_sante_modale_telecharger" | translate("fr") }}
        </div>
      </div>

      <div v-if="getAgeParDateCourante() < 18" class="row mt-3 ml-5">
        <div @click="downloadQuestionnaireSanteMineur">
          <img
            :src="require('@/assets/download.png')"
            style="cursor:pointer;"
          />
        </div>
        <div
          class="mes-justificatifs-text downloadQuestionnaireSante ml-2"
          @click="downloadQuestionnaireSanteMineur"
        >
          {{
            "questionnaire_sante_mineur_modale_telecharger" | translate("fr")
          }}
        </div>
      </div>

      <label
        v-if="getAgeParDateCourante() >= 18"
        class="mes-justificatifs-text mt-4"
        ><input
          type="checkbox"
          class="modal-check-label"
          v-model="isNegativeAcceptee"
          @change="checkNegativeMethod"
        />
        {{
          "questionnaire_sante_modale_check_negative" | translate("fr")
        }}</label
      >

      <label
        v-if="getAgeParDateCourante() < 18"
        class="mes-justificatifs-text mt-4"
        ><input
          type="checkbox"
          class="modal-check-label"
          v-model="isNegativeAcceptee"
          @change="checkNegativeMethod"
        />
        {{
          "questionnaire_sante_mineur_modale_check_negative" | translate("fr")
        }}</label
      >

      <label class="mes-justificatifs-text mt-4"
        ><input
          type="checkbox"
          class="modal-check-label"
          v-model="isPositiveAcceptee"
          @change="checkPositiveMethod"
        />
        {{
          "questionnaire_sante_modale_check_positive" | translate("fr")
        }}</label
      >

      <p
        v-if="questionnaireSanteValidationMsg != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        {{ questionnaireSanteValidationMsg }}
      </p>

      <template v-slot:modal-title>
        <div class="text-center">
          <img :src="require('@/assets/file-minus-white.png')" /><br />
          QUESTIONNAIRE DE SANTÉ
        </div>
      </template>

      <template v-slot:modal-footer>
        <div class="w-100 text-center">
          <b-button
            variant="primary"
            @click="sauvegardeConfirmation"
            class="modal-button"
          >
            ENREGISTRER
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import translations from "@/Translations.js";

export default {
  props: ["preinscription", "isPresent"],
  data() {
    return {
      isNegativeAcceptee: false,
      isPositiveAcceptee: false,
      confirmationSoumis: false,
      negativeValeurSoumise: false,
      positiveValeurSoumise: false,
      questionnaireSanteValidationMsg: null
    };
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  methods: {
    sauvegardeConfirmation() {
      if (!this.isNegativeAcceptee && !this.isPositiveAcceptee) {
        this.questionnaireSanteValidationMsg =
          "Il est nécessaire de remplir une case à cocher pour pouvoir continuer";
        return;
      }

      this.negativeValeurSoumise = this.isNegativeAcceptee;
      this.positiveValeurSoumise = this.isPositiveAcceptee;
      this.confirmationSoumis = this.negativeValeurSoumise ? false : true;
      this.$refs["modal-questionnaire-sante"].hide();
      this.$emit("getQuestionnaireSanteAcceptee", this.confirmationSoumis);
    },
    resetModale() {
      this.questionnaireSanteValidationMsg = null;

      this.isNegativeAcceptee = this.negativeValeurSoumise;
      this.isPositiveAcceptee = this.positiveValeurSoumise;
    },
    checkNegativeMethod() {
      this.questionnaireSanteValidationMsg = null;
      if (this.isNegativeAcceptee) {
        this.isPositiveAcceptee = false;
      }
    },
    checkPositiveMethod() {
      this.questionnaireSanteValidationMsg = null;
      if (this.isPositiveAcceptee) {
        this.isNegativeAcceptee = false;
      }
    },
    downloadQuestionnaireSanteMajeur() {
      preinscriptionAppelsServeur.downloadQuestionnaireSanteMajeur();
    },
    downloadQuestionnaireSanteMineur() {
      preinscriptionAppelsServeur.downloadQuestionnaireSanteMineur();
    },
    getAgeParDateCourante() {
      if (!this.preinscription.data) {
        return 0;
      }
      var dateNaissance = this.preinscription.data.dateNaissance;
      return preinscriptionAppelsServeur.getAgeLicencieParDateCourante(
        dateNaissance
      );
    }
  },
  mounted() {
    if (this.isPresent === true) {
      this.negativeValeurSoumise = true;
    }
  }
};
</script>

<style scoped>
.modal-body label {
  display: block;
  padding-left: 35px;
  text-indent: -35px;
  font-style: italic;
}
.modal-body label input {
  vertical-align: bottom;
  margin-right: 10px;
}

.modal-body a {
  text-decoration: underline;
  font-weight: bold;
  margin-left: 15px;
}

.questionnaire-sante-component:hover {
  border-color: #003690;
}

.downloadQuestionnaireSante {
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
}
</style>
